import { render, staticRenderFns } from "./EditAnnouncements.vue?vue&type=template&id=a79bff7a&scoped=true&"
import script from "./EditAnnouncements.vue?vue&type=script&lang=js&"
export * from "./EditAnnouncements.vue?vue&type=script&lang=js&"
import style0 from "./EditAnnouncements.vue?vue&type=style&index=0&id=a79bff7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79bff7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VContainer,VIcon,VRow})
